var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('h1',[_vm._v("Tegola ("+_vm._s(_vm.capabilities.version)+")")])])}
var staticRenderFns = []

export { render, staticRenderFns }